import React from 'react';

import Modal from 'components/shared/Modal';
import Button from 'components/shared/Button';

import type { NamedCollection } from 'domains/photos';

type DeleteCollectionModalProps = {
  pendingDelete: NamedCollection;
  onConfirm: (name: string) => void;
  onCancel: () => void;
};

export function DeleteCollectionModal(props: DeleteCollectionModalProps) {
  const { pendingDelete, onConfirm, onCancel } = props;

  const buttons = (
    <React.Fragment>
      <Button type="confirm" onClick={() => onConfirm(pendingDelete.name)}>
        Confirm
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      title={`Remove collection ${pendingDelete.name}`}
      labelledBy="delete-collection-modal"
      modalClass={['collections-manager']}
      primaryFooterGroup={buttons}
      onClose={onCancel}
      lastFocusedElementId="collections-menu-trigger"
    >
      <div className="collections_manager_container">
        <div className="collections_manager_items confirm_delete animated fadeIn">
          <strong className="confirm_delete_title">
            There {pendingDelete.count !== 1 ? 'are' : 'is'} {pendingDelete.count} image
            {pendingDelete.count !== 1 ? 's' : ''} in this collection.{' '}
            {pendingDelete.count !== 1 ? 'They' : 'It'} will be deleted.
          </strong>
          <div className="confirm_delete_message">
            Are you sure you want to remove the collection &lsquo;{pendingDelete.name}&rsquo;? This
            cannot be undone.
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteCollectionModal;
